import { AwsRum, type AwsRumConfig } from 'aws-rum-web';

export interface InitAwsRumOptions {
  /** 必填：应用 ID */
  applicationId: string;
  /** 必填：身份池 ID */
  identityPoolId: string;
  /** 应用版本，默认 '1.0.0' */
  applicationVersion?: string;
  /** 应用区域，默认 'us-east-1' */
  applicationRegion?: string;
  /** 会话采样率，默认 1 */
  sessionSampleRate?: number;
  /** RUM 数据端点，默认 'https://dataplane.rum.us-east-1.amazonaws.com' */
  endpoint?: string;
  /** 遥测类型，默认 ['performance', 'errors', 'http'] */
  telemetries?: AwsRumConfig['telemetries'];
  /** 是否允许 cookies，默认 false */
  allowCookies?: boolean;
  /** 是否启用 X-Ray，默认 false */
  enableXRay?: boolean;
  /** 是否签名请求，默认 true */
  signing?: boolean;
}

export function initAwsRum(options: InitAwsRumOptions) {
  const {
    applicationId,
    identityPoolId,
    applicationVersion = '1.0.0',
    applicationRegion = 'us-east-1',
    sessionSampleRate = 1,
    endpoint = 'https://dataplane.rum.us-east-1.amazonaws.com',
    telemetries = ['performance', 'errors', 'http'],
    allowCookies = false,
    enableXRay = false,
    signing = true,
  } = options;

  try {
    const config: AwsRumConfig = {
      sessionSampleRate,
      identityPoolId,
      endpoint,
      telemetries,
      allowCookies,
      enableXRay,
      signing,
    };

    new AwsRum(applicationId, applicationVersion, applicationRegion, config);
  } catch (error) {
    console.error('Failed to initialize CloudWatch RUM web client', error);
    // Ignore errors thrown during CloudWatch RUM initialization
  }
}

